import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { themeProvider } from '../../themeProvider';
import VesselSchedulePage from './VesselSchedulePage';

const VesselSchedule: React.FC = () => (
  <ThemeProvider theme={themeProvider}>
    <VesselSchedulePage />
  </ThemeProvider>
);
VesselSchedule.displayName = 'VesselSchedule';

export default VesselSchedule;
